export default "__VITE_ASSET__9b3e438d__"